"use client";

import React from "react";
import { Mail, MapPin, Phone, Loader, CircleCheck, CircleAlert } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-16 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
          <CircleCheck className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-default font-semibold text-foreground">Շնորհակալություն</h3>
        <p className="text-muted-foreground max-w-md">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-6">
          Ուղարկել նոր հարցում
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Անունը պարտադիր է",
        minLength: {
          value: 2,
          message: "Նվազագույնը 2 նիշ"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Անուն Ազգանուն</FormLabel>
              <FormControl>
                <Input placeholder="Ձեր անունը" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Էլ. փոստը պարտադիր է",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Անվավեր էլ. փոստի հասցե"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Էլ. փոստ</FormLabel>
              <FormControl>
                <Input type="email" placeholder="orinak@mail.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="service" rules={{
      required: "Խնդրում ենք ընտրել ծառայությունը"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Ծառայության տեսակ</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Ընտրեք հետաքրքրող ծառայությունը" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="satellite">Արբանյակային Պատկերների Ստացում</SelectItem>
                <SelectItem value="photogrammetry">Ֆոտոգրամետրիական աշխատանքներ</SelectItem>
                <SelectItem value="geodesy">Գեոդեզիական աշխատանքներ</SelectItem>
                <SelectItem value="consultation">Տեխնիկական խորհրդատվություն</SelectItem>
                <SelectItem value="other">Այլ</SelectItem>
              </SelectContent>
            </Select>
            <FormDescription>
              Նշեք այն ոլորտը, որի վերաբերյալ ցանկանում եք ստանալ տեղեկատվություն:
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Հաղորդագրությունը պարտադիր է",
      minLength: {
        value: 10,
        message: "Նվազագույնը 10 նիշ"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Հաղորդագրություն</FormLabel>
            <FormControl>
              <Textarea placeholder="Նկարագրեք ձեր հարցը կամ նախագիծը..." className="min-h-[120px] resize-y" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg flex items-start gap-3">
          <CircleAlert className="size-5 text-destructive shrink-0 mt-0.5" />
          <p className="text-sm text-destructive">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto min-w-[200px]" size="lg">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Ուղարկվում է...
          </> : 'Ուղարկել հարցումը'}
      </Button>
    </Form>;
}
export default function ContactSection() {
  const contactInfo = [{
    icon: <MapPin className="size-6 text-primary" />,
    title: "Հասցե",
    details: "ք. Երևան, Հայաստան",
    description: "Այցելեք մեր գրասենյակ խորհրդատվության համար"
  }, {
    icon: <Phone className="size-6 text-primary" />,
    title: "Հեռախոս",
    details: "+374 10 000 000",
    description: "Երկուշաբթի - Ուրբաթ, 09:00 - 18:00"
  }, {
    icon: <Mail className="size-6 text-primary" />,
    title: "Էլ. փոստ",
    details: "info@example.am",
    description: "Ուղարկեք մեզ նամակ ցանկացած ժամանակ"
  }];
  return;
}